<template>
  <header class="header-container">
    <div class="header-content">
      <!-- Left: Logo -->
      <div class="header-left">
        <router-link to="/" class="header-logo">
          <img :src="logoSrc" alt="英才计划" class="logo-image" />
        </router-link>
      </div>

      <!-- Center: Nav -->
      <div class="header-center">
        <nav class="header-nav">
          <router-link to="/" exact class="nav-item">首页</router-link>
          <router-link to="/study" class="nav-item">学习</router-link>
          <router-link to="/exam" class="nav-item">考试</router-link>
          <router-link to="/certification" class="nav-item">认证</router-link>
          <router-link to="/employment" class="nav-item">就业</router-link>
        </nav>
      </div>

      <!-- Right: Search + User -->
      <div class="header-right">
        <div class="search-wrapper" v-if="!isSearchPage">
          <el-input
            v-model="searchText"
            :placeholder="hotKeyword"
            size="small"
            class="search-input-round"
            @keyup.enter.native="submitSearch"
            @focus="navigateToSearch"
          >
            <i slot="suffix" class="el-icon-search search-icon" @click="submitSearch"></i>
          </el-input>
        </div>

        <div class="divider">|</div>

        <div class="cart-wrapper" v-if="isLoggedIn" @click="goToCart">
          <el-badge :value="cartCount" :hidden="cartCount === 0" :max="99" class="cart-badge">
            <img src="@/assets/image/icon_cart_white.png" alt="购物车" class="cart-icon">
          </el-badge>
        </div>

<div class="user-actions">
           <template v-if="!isLoggedIn">
             <span class="action-item" @click="$emit('open-login')">登录</span>
             <span class="action-item" @click="$emit('open-register')">注册</span>
           </template>
           <template v-else>
             <span class="action-item" @click="handleMemberCenter">会员中心</span>
             <span class="action-item" @click="handleMyCourses">我的课程</span>
             <div class="bell-wrapper" @click="openMessages" style="margin-right: 20px; cursor: pointer; display: flex; align-items: center; color: rgba(255,255,255,0.9);">
               <el-badge :value="unreadMessageCount" :hidden="unreadMessageCount === 0" :max="99" class="bell-badge">
                 <i class="el-icon-bell" style="font-size: 22px;"></i>
               </el-badge>
             </div>
             <div class="user-avatar" @click="handleMemberCenter">
                <img v-if="userAvatar" :src="userAvatar" class="avatar-img" />
                <i v-else class="el-icon-user-solid"></i>
             </div>
           </template>
         </div>
       </div>
     </div>
   </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getHotKeywords } from '@/api/homeApi'
import { getCartList } from '@/api/cartApi'
import { getPersonalOverview } from '@/api/authApi'

export default {
  name: 'AppHeader',
  data() {
    return {
      searchText: '',
      hotKeyword: '',
      cartCount: 0,
      unreadMessageCount: 0
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'username', 'userInfo']),
    isIndex() { return this.$route && this.$route.name === 'index' },
    isSearchPage() { return this.$route && this.$route.name === 'search' },
    userAvatar() {
      return this.userInfo && this.userInfo.avatar
    },
    logoSrc() {
      return require('@/assets/new_picture/logo_w.png')
    }
  },
  created() {
    this.syncSearchTextByRoute(this.$route)
    this.fetchHotKeyword()
    this.fetchCartCount()
    this.fetchUnreadMessageCount()
    window.addEventListener('message-read', this.fetchUnreadMessageCount)
    window.addEventListener('cart-updated', this.fetchCartCount)
  },
  beforeDestroy() {
    window.removeEventListener('message-read', this.fetchUnreadMessageCount)
    window.removeEventListener('cart-updated', this.fetchCartCount)
  },
  watch: {
    $route(to) {
      this.syncSearchTextByRoute(to)
      if (to.path === '/member-center/messages') {
        this.fetchUnreadMessageCount()
      }
    },
    isLoggedIn(val) {
      if (val) {
        this.fetchCartCount()
        this.fetchUnreadMessageCount()
      } else {
        this.cartCount = 0
        this.unreadMessageCount = 0
      }
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    fetchHotKeyword() {
      getHotKeywords().then(res => {
        if (res && res.code === 200 && res.data && res.data.length > 0) {
          const randomIndex = Math.floor(Math.random() * res.data.length)
          this.hotKeyword = res.data[randomIndex].keyword || ''
        }
      }).catch(err => {
        console.error('Failed to fetch hot keywords:', err)
      })
    },
    async fetchCartCount() {
      if (!this.isLoggedIn) {
        this.cartCount = 0
        return
      }
      try {
        const res = await getCartList()
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.cartCount = res.data.length
        } else if (res && res.data && Array.isArray(res.data.list)) {
          this.cartCount = res.data.list.length
        } else {
          this.cartCount = 0
        }
      } catch (err) {
        this.cartCount = 0
      }
    },
    goToCart() {
      this.$router.push('/cart').catch(() => {})
    },
    async fetchUnreadMessageCount() {
      if (!this.isLoggedIn) {
        this.unreadMessageCount = 0
        return
      }
      try {
        const res = await getPersonalOverview()
        const data = res && res.data
        this.unreadMessageCount = Number(data && data.unreadMessageCount) || 0
      } catch (err) {
        this.unreadMessageCount = 0
      }
    },
    openMessages() {
      this.$router.push('/member-center/messages').catch(() => {})
    },
    isActive(path) {
      return this.$route.path === path
    },
    syncSearchTextByRoute(route) {
      const name = route && route.name
      const enabled = name === 'study' || name === 'index' || name === 'exam' || name === 'search'
      if (!enabled) {
        this.searchText = ''
        return
      }
      this.searchText = String((route && route.query && route.query.keyword) || '').trim()
    },
    submitSearch() {
      let keyword = String(this.searchText || '').trim()
      
      if (!keyword && this.hotKeyword) {
        keyword = this.hotKeyword
      }

      if (!keyword) {
        return
      }
      
      let type = 'course'
      if (this.$route.name === 'search' && this.$route.query.type) {
        type = this.$route.query.type
      }

      const query = { keyword, type }
      
      if (this.$route.name === 'search') {
        this.$router.replace({ name: 'search', query })
      } else {
        this.$router.push({ name: 'search', query })
      }
    },
    navigateToSearch() {
      if (this.$route.name !== 'search') {
        this.$router.push({ name: 'search', query: { keyword: this.searchText || '', type: 'course' } })
      }
    },
    handleMemberCenter() {
      if (this.$route.path !== '/member-center/settings') {
        this.$router.push('/member-center/settings').catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err
        })
      }
    },
    handleMyCourses() {
      if (this.$route.path !== '/member-center/courses') {
        this.$router.push('/member-center/courses').catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 64px;
  transition: all 0.3s;
  background-color: #3E2CCD;
}

/* Removed .is-index and .is-light specific background colors */
/* .header-container.is-index { background-color: #3E2CCD; box-shadow: none; } */
/* .header-container.is-light { background-color: #ffffff; box-shadow: 0 2px 8px rgba(0,0,0,.06); } */

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.logo-image {
  height: 92px;
  width: auto;
  display: block;
}
.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
}
.header-nav {
  display: flex;
  gap: 40px;
}
.nav-item {
  font-size: 16px;
  text-decoration: none;
  color: rgba(255,255,255,0.9);
  transition: color 0.3s;
}
.nav-item:hover, .nav-item.router-link-exact-active {
  color: #fff;
  font-weight: 500;
}
.is-light .nav-item { color: #606266; }
.is-light .nav-item:hover, .is-light .nav-item.router-link-exact-active { color: #3E2CCD; }

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.search-wrapper {
  width: 220px;
}
::v-deep .search-input-round .el-input__inner {
  border-radius: 20px;
  background: rgba(255,255,255,0.2);
  border: 1px solid transparent;
  color: #fff;
  height: 32px;
  line-height: 32px;
  padding-right: 30px; /* Space for icon */
  transition: all 0.3s;
}
::v-deep .search-input-round .el-input__inner:focus {
  background: rgba(255,255,255,0.3);
}
::v-deep .search-input-round .el-input__inner::placeholder {
    color: rgba(255,255,255,0.6);
}

.is-light .search-input-round ::v-deep .el-input__inner {
  background: #f0f2f5;
  color: #303133;
  border: 1px solid #e4e7ed;
}
.is-light .search-input-round ::v-deep .el-input__inner:focus {
  background: #fff;
  border-color: #3E2CCD;
}
.is-light .search-input-round ::v-deep .el-input__inner::placeholder {
    color: #909399;
}

.search-icon {
  cursor: pointer;
  color: #fff;
  line-height: 32px;
  font-size: 16px;
  margin-right: 5px;
}
.is-light .search-icon { color: #909399; }

.divider {
  color: rgba(255,255,255,0.4);
  font-size: 14px;
  margin: 0 5px;
}
.is-light .divider { color: #dcdfe6; }

.user-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  color: #fff;
  font-size: 14px;
}
.is-light .user-actions { color: #606266; }

.action-item {
  cursor: pointer;
  transition: opacity 0.3s;
  &:hover { opacity: 0.8; }
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  transition: opacity 0.3s;
  &:hover { opacity: 0.8; }
  i { font-size: 20px; color: #fff; }
  .avatar-img { width: 100%; height: 100%; object-fit: cover; }
}
.is-light .user-avatar {
  background: #f0f2f5;
  i { color: #909399; }
}

.cart-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: opacity 0.3s;
  
  &:hover {
    opacity: 0.8;
  }
}

.cart-icon {
  width: 20px;
  height: 20px;
  display: block;
}

.cart-badge ::v-deep .el-badge__content {
  background-color: #ff4d4f;
  height: 14px;
  line-height: 14px;
  padding: 0 4px;
  font-size: 10px;
}

.bell-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s;
  margin: 0 5px;
  height: 32px;
  
  &:hover {
    opacity: 0.8;
  }
}

.bell-icon {
  width: 20px;
  height: 20px;
  display: block;
  margin-top: 2px;
}

.bell-badge ::v-deep .el-badge__content {
  background-color: #ff4d4f;
  height: 14px;
  line-height: 14px;
  padding: 0 4px;
  font-size: 10px;
}
</style>
